<template>
  <div>
    <mainHeader></mainHeader>
    <div class="container">
      <div class="row has-header pb-15">
        <div class="mt-24">
          <span class="color_team ml-12 cursor_pointer" v-on:click="goToAllTeams">Team</span>
          <span class="color_profile">&nbsp;/ Settings</span>
        </div>
      </div>
      <div class="av-research-team-settings-main-container container-fluid">
        <div class="settings-container col-md-12">
          <p class="card-deactivation-header">
            Enable automatic Research Team deactivation
          </p>
          <p class="card-deactivation-text">
            Configure a timeframe for when research team members will be automatically deactivated from the platform due to inactivity.
          </p>
          <div class="switch-button d-flex">
            <div class="enable-config-deactivation-text col-md-4 p-0 color_666669">
              Enable Configurable Deactivation
            </div>
            <span class="setting-btn-text">Off</span>
            <div class="switch-option">
              <label class="switch">
                <input type="checkbox" v-model="userDeactivationConfigured" />
                <div tabindex="14" class="slider round"></div>
              </label>
              <span class="setting-btn-text-on setting-btn-text">On</span>
            </div>
          </div>
          <div>
            <p v-if="userDeactivationConfigured" class="enable-config-deactivation-text pt-10">
              Timeframe of inactivity
            </p>
            <div v-if="userDeactivationConfigured" class="form-group d-flex">
              <input type="text" min="1" @input="numberOnly" onpaste="return false;" v-model="userDeactivationDays" class="form-control timeframe-input" />
              <input type="text" disabled v-model="label" class="form-control timeframe-inputDays" />
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button type="button" @click="goToAllTeams" class="btn btn-deactivate-cancel mr-15">
              Cancel
            </button>
            <button type="button" :disabled="!isSaveSettings || (decimalError && userDeactivationConfigured)" @click="onSaveSettings" class="btn btn-deactivate-save">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mainHeader from "../common/main-header";
export default {
  name: "research-team-deactivation-settings",
  data() {
    return {
      clientId: this.$route.params.clientId,
      userDeactivationConfigured: false,
      userDeactivationDays: 90,
      label: "Days",
      invalidNumberError: "",
      userDetails: "",
      decimalError: false
    };
  },
  components: { mainHeader },
  mounted() {
    this.$api
      .getUserSettingsFact(this.clientId)
      .then(res => {
        this.userDetails = res.body;
        if (this.userDetails && (this.userDetails.userDeactivationConfigured || this.userDetails.userDeactivationDays)) {
          this.userDeactivationConfigured = this.userDetails.userDeactivationConfigured;
          this.userDeactivationDays = this.userDetails.userDeactivationDays;
        }
      })
      .catch(() => {
        this.$toastr.error("Error while getting the user details");
      });
  },
  watch: {
    userDeactivationConfigured() {
      if (!this.userDeactivationConfigured) {
        this.userDeactivationDays = 90;
      }
    }
  },
  computed: {
    isSaveSettings() {
      return !!(this.userDeactivationConfigured !== (this.userDetails && this.userDetails.userDeactivationConfigured) || (this.userDeactivationConfigured && this.userDeactivationDays != (this.userDetails && this.userDetails.userDeactivationDays)));
    }
  },
  methods: {
    goToAllTeams() {
      this.$router.push({ name: "users" });
    },
    numberOnly() {
      const regExWholeNumber = "-?[0-9]+?";
      const regExpWholeNumber = new RegExp(`^${regExWholeNumber}$`);
      if (!regExpWholeNumber.test(this.userDeactivationDays)) {
        this.decimalError = true;
        this.$toastr.error("Partial days are not allowed. Please enter a number between 1 and 999999.");
      } else {
        this.decimalError = false;
      }
    },
    validateNumber() {
      if (this.userDeactivationConfigured && (!this.userDeactivationDays || Number(this.userDeactivationDays) === 0 || Number(this.userDeactivationDays) > 999999)) {
        this.invalidNumberError = "Partial days are not allowed. Please enter a number between 1 and 999999.";
      } else {
        this.invalidNumberError = "";
      }
      return this.invalidNumberError;
    },
    onSaveSettings() {
      const isNumberError = this.validateNumber();
      if (this.userDetails) {
        this.userDetails.userDeactivationDays = this.userDeactivationDays;
        this.userDetails.userDeactivationConfigured = this.userDeactivationConfigured;
      }
      if (isNumberError) {
        this.$toastr.error(isNumberError);
        return;
      }
      this.$api
        .userDeactivation(this.clientId, this.userDeactivationConfigured, this.userDetails)
        .then(() => {
          this.goToAllTeams();
        })
        .catch(() => {
          this.$toastr.error("Error while saving the user settings.");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.color_team {
  color: #4c8ce4;
  font-family: Roboto-Regular;
  font-size: 15px;
}
.av-research-team-settings-main-container {
  .deactivation_title {
    font-size: 20px;
    font-weight: bold;
    line-height: 2.05;
    text-align: left;
    color: #666669;
  }
  .settings-container {
    height: auto;
    padding: 29px 40px 29px 29px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
    background-color: #fff;
  }
  .card-deactivation-header {
    font-size: 16px;
    font-weight: bold;
    line-height: 1.5;
    text-align: left;
    color: #666669;
  }
  .card-deactivation-text {
    opacity: 0.7;
    font-size: 14px;
    line-height: 1.43;
    text-align: left;
    color: #666669;
  }
  .setting-btn-text {
    position: relative;
    right: 5px;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    color: #b0bac9;
  }
  .setting-btn-text-on {
    right: 1px !important;
  }
  .switch-button {
    font-size: 14px;
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 38px;
    height: 23px;
    float: left;
    margin-right: 5px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    display: none;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 2px solid #ccc;
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 1.5px;
    background-color: #ccc;
  }
  input:checked + .slider {
    border: 2px solid #48bf7a;
  }
  input:checked + .slider:before {
    content: "";
    background-color: #48bf7a;
  }
  input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }
  input:checked + .slider:before {
    /*content: '✓';*/
    position: absolute;
    color: #2ecc71;
    text-align: center;
    font-size: 20px;
    -webkit-transform: translateX(14px);
    -ms-transform: translateX(14px);
    transform: translateX(14px);
  }
  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }
  .slider.round:before {
    border-radius: 50%;
  }
  .enable-config-deactivation-text {
    opacity: 0.7;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.43;
    text-align: left;
    color: #666669;
  }
  .error-style {
    font-size: 12px;
    color: #ff4848;
    padding-bottom: 5px;
  }
  .settings-container .timeframe-input {
    width: 120px;
    height: 40px;
    border: solid 1px #d3dee3;
    background-color: #fff;
    text-align: center;
    font-size: 14px;
    line-height: 1.43;
    color: #666669;
  }
  .settings-container .timeframe-inputDays {
    width: 90px;
    height: 40px;
    text-align: center;
    border: solid 1px #d3dee3;
    font-size: 14px;
    background-color: rgba(211, 223, 228, 0.1);
    line-height: 1.43;
    color: #666669;
  }
  .settings-container .btn-deactivate-cancel {
    opacity: 0.7;
    font-size: 14px;
    line-height: 1.43;
    text-align: left;
    color: #666669;
  }
  .settings-container .btn-deactivate-cancel:focus {
    box-shadow: none;
  }
  .settings-container .btn-deactivate-save {
    height: 35px;
    border-radius: 4px;
    background-color: #4c8ce4;
    padding: 0 40px;
    font-size: 14px;
    line-height: 1.43;
    text-align: center;
    color: #fff;
  }
  .btn-wrapper {
    padding-top: 125px;
  }
}
</style>
